<template>
    <div
        class="col-span-12 text-left flex items-end justify-between w-full mb-2"
    >
        <ResultsCount
            :startRange="startRange"
            :endRange="endRange"
            :totalResults="totalResults"
        />
        <div class="h-5 justify-end items-start inline-flex gap-6">
            <button
                v-if="searchResults.data.length > 0"
                @click="showSearchResultsOnMap"
                @keydown.enter.prevent="showSearchResultsOnMap"
                class="text-opacity-95 text-sm font-medium leading-tight text-black focus:outline-slate-300 rounded"
            >
                <div
                    class="justify-start items-start gap-2 flex p-1 hover:text-slate-500"
                >
                    <div class="w-5 h-5"><i class="fa-regular fa-map"></i></div>
                    <span class="inline">
                        {{ showOnMap ? 'Hide map' : 'Open Map View' }}
                    </span>
                </div>
                <span class="md:hidden">
                    <i
                        class="fa-solid fa-chevron-down -mr-1 ml-2 h-3 hover:text-orange-100"
                    ></i>
                </span>
            </button>
            <InputSelect
                v-if="!showOnMap"
                class="hover:text-slate-500"
                inputStyles="text-slate-800"
                optionsStyles="right-0"
                :previouslySelected="sort"
                :options="[
                    { name: 'Sort By', value: null },
                    {
                        name: 'Points Price - Low to High',
                        value: 'min_points',
                    },
                    {
                        name: 'Points Price - High to Low',
                        value: 'max_points',
                    },
                    {
                        name: 'Cash Price - Low to High',
                        value: 'min_rate',
                    },
                    {
                        name: 'Cash Price - High to Low',
                        value: 'max_rate',
                    },
                    { name: 'CPP - Highest to Lowest', value: 'max_cpp' },
                    // { name: 'CPP - Lowest to Highest', value: 'min_cpp' },
                    {
                        name: 'Location - Closest to Furthest',
                        value: 'distance',
                        disabled: !searchLocation,
                    },
                    {
                        name: 'Location - Furthest to Closest',
                        value: '-distance',
                        disabled: !searchLocation,
                    },
                ]"
                @sort="(input) => sortProperties(input, 'search')"
            />
        </div>
    </div>
</template>

<script>
import InputSelect from '@/components/ui/inputs/input-select.vue';
import ResultsCount from '@/components/ui/results-count/results-count.vue';
import { useHotelsStore } from '@/store/hotels';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

export default {
    components: { InputSelect, ResultsCount },
    setup() {
        const hotelsStore = useHotelsStore();
        const {
            filteredSearchResults,
            showOnMap,
            searchLocation,
            searchResults,
            sort,
            startRange,
            endRange,
        } = storeToRefs(hotelsStore);
        const { setShowOnMap, sortProperties } = hotelsStore;

        const totalResults = computed(() => filteredSearchResults.value.length);

        const showSearchResultsOnMap = () => {
            let val = !showOnMap.value;
            setShowOnMap(val);
        };

        return {
            filteredSearchResults,
            showSearchResultsOnMap,
            hotelsStore,
            searchLocation,
            searchResults,
            showOnMap,
            sort,
            startRange,
            endRange,
            totalResults,
        };
    },
};
</script>
